import { useAuthContext } from '@contexts/auth';
import type { FormErrors } from '@customTypes/errors';
import api from '@services/api';
import Cookies from 'js-cookie';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

const useForm = () => {
  const { setRoles } = useAuthContext();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<FormErrors | null>(null);
  
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const data = Object.fromEntries(formData.entries());

    setLoading(true);
    setErrors(null);

    try {
      const response = await api.post('/account/login', {
        email: data.email,
        password: data.password,
      });

      if (response.data.access_token) {
        const { access_token, expiration, name, email } = response.data;

        if (window?.clarity) {
          window.clarity('identify', email, '', '', name);
        }

        localStorage.setItem('@UserRoles', JSON.stringify(response.data.roles));
        
        setRoles(response.data.roles);

        Cookies.set('accessToken', access_token, {
          expires: new Date(expiration),
          path: '/',
        });

        navigate('/painel', { replace: true });
      } else if (response.data.errors) {
        setErrors(response.data.errors);
      }
    } catch {
      toast.error('Erro ao fazer login. Verifique suas credenciais e tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return {
    onSubmit,
    loading,
    errors,
  };
};

export default useForm;
